module.exports = __webpack_public_path__ + "img/frame (154).9bdc30ae.jpg";